import { renderMagazineSwiper } from 'js/magazin/initMagazineSwiper'

export const renderSliderFullMagazine = (slider) => renderMagazineSwiper(slider, {
  containerSelector: '.slider-full-magazine-container',
  theme: 'white',
  mobileMax: 1,
  desktopMax: 1,
  overrides: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
  },
})
